<template>
  <div class="validate-user" :class="state.type">
    <div class="title-img" :class="state.locale"></div>
    <div class="form" v-if="!state.cpUserInfo.cpUserId">
      <div class="form-item">
        <div class="form-item-label user-id" @click="openUserGuide">
          <i class="icon-question"></i>
          {{ $t('payment.validateUser.desc') }}
        </div>
        <div class="form-item-input">
          <input :class="state.locale" :value="state.userId" @input="handleInput" type="text" :placeholder="$t('payment.validateUser.enterUserId')">
        </div>
        <div class="form-item-button">
          <button class="btn submit-btn" @click="handleSubmit">{{ $t('payment.validateUser.submit') }}</button>
        </div>
      </div>
    </div>
    <div class="validate-user-success" v-else>
      <div class="user-info">
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.id') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpUserId }}
          </span>
        </div>
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.name') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpNickName }}
          </span>
        </div>
      </div>
      <ActButton class="reset-btn" type="yellow" @click="resetUserInfo">{{ $t('payment.userDialog.cancelInput') }}</ActButton>
    </div>
    <Dialog v-model="state.dialog.visible" type="validateUser">
      <div class="dialog-content">
        <div class="info">
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.id') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpUserId }}
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.name') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpNickName }}
            </div>
          </div>
        </div>
        <div class="btn-box">
          <ActButton type="blue" size="small" @click="handleConfirm">{{ $t('payment.userDialog.confirmInput') }}</ActButton>
          <ActButton type="yellow" size="small" @click="handleCancel">{{ $t('payment.userDialog.cancelInput') }}</ActButton>
        </div>
      </div>
    </Dialog>
    <div v-if="state.showImageViewer">
      <el-image-viewer
        v-if="state.showImageViewer"
        hide-on-click-modal
        :url-list="state.imageList"
        :initial-index="0"
        :z-index="9999"
        teleported
        @close="closeImageViewer"
      />
    </div>
  </div>
</template>

<script setup>
import useValidateUser from '../script'
import Dialog from '@/components/Dialog/ActAccumRecharge'
import ActButton from '@/views/act/accumRecharge/components/ActButton'
import { ElImageViewer } from 'element-plus'
import { defineEmits } from 'vue'
const emit = defineEmits(['resetUserInfo', 'getUserInfoSuccess'])
const { state, handleSubmit, handleInput, handleConfirm, handleCancel, resetUserInfo, openUserGuide, closeImageViewer } = useValidateUser(emit)
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
